'use client';

import { Lottie } from 'lottie-react';
import React, { useMemo } from 'react';

import { LottieAnimationProps } from '../types';

/**
 * Компонента для отображения Lottie-анимаций.
 * Использует библиотеку lottie-react.
 *
 * Пример использования:
 * <LottieAnimation animationData={animationJson} loop autoplay className="w-64 h-64" />
 */
export const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  loop = true,
  autoplay = true,
  className,
  lottieClassName,
  width,
  height,
}) => {
  /**
   * Своя копия данных на каждый инстанс.
   *
   * lottie-react 3 отдаёт движку поверхностную копию animationData, поэтому
   * флаг `__complete`, которым lottie-web помечает уже разобранные данные,
   * до второго инстанса не доезжает — а вложенные `layers` и `chars` у копий
   * общие. В итоге второй инстанс повторно прогоняет разбор по уже
   * сконвертированным глифам и рвёт текстовые слои. Проявляется, когда одну
   * и ту же импортированную JSON-анимацию рендерят дважды (мобильная и
   * десктопная версии блока живут в DOM одновременно, скрыта только CSS).
   */
  const ownAnimationData = useMemo(
    () => structuredClone(animationData),
    [animationData],
  );

  return (
    <div className={className} style={{ width, height }}>
      <Lottie
        className={lottieClassName}
        src={ownAnimationData}
        loop={loop}
        autoplay={autoplay}
      />
    </div>
  );
};
